import { render, staticRenderFns } from "./_MainShare.vue?vue&type=template&id=0568d3b2&"
import script from "./_MainShare.vue?vue&type=script&lang=js&"
export * from "./_MainShare.vue?vue&type=script&lang=js&"
import style0 from "./_MainShare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports